import React from 'react';
import classnames from 'classnames';

import styles from './index.module.css';

interface SquareBracketProperty {
	className?: string;
	side: 'left' | 'right';
}

const SquareBracket: React.FC<SquareBracketProperty> = ({ className, side }) => (
	<div
		className={classnames(styles.squareBracket, className, {
			[styles.sideRight]: side === 'right',
		})}
	>
		<span />
		<span />
		<span />
	</div>
);

export default SquareBracket;
